import { createContext, useCallback, useContext, useMemo, useState } from "react";

const STORAGE_KEY = "openreferences_auth_pending_verification_email";

const RegistrationVerificationContext = createContext(null);

function readStoredEmail() {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) || "";
  } catch (error) {
    return "";
  }
}

export function RegistrationVerificationProvider({ children }) {
  const [pendingVerificationEmail, setPendingVerificationEmailState] = useState(readStoredEmail);

  const setPendingVerificationEmail = useCallback((email) => {
    setPendingVerificationEmailState(email);

    try {
      window.sessionStorage.setItem(STORAGE_KEY, email);
    } catch (error) {
      return;
    }
  }, []);

  const clearPendingVerificationEmail = useCallback(() => {
    setPendingVerificationEmailState("");

    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      return;
    }
  }, []);

  const value = useMemo(
    () => ({
      clearPendingVerificationEmail,
      pendingVerificationEmail,
      setPendingVerificationEmail,
    }),
    [clearPendingVerificationEmail, pendingVerificationEmail, setPendingVerificationEmail],
  );

  return (
    <RegistrationVerificationContext.Provider value={value}>{children}</RegistrationVerificationContext.Provider>
  );
}

export function useRegistrationVerification() {
  const context = useContext(RegistrationVerificationContext);

  if (!context) {
    throw new Error("useRegistrationVerification must be used within RegistrationVerificationProvider");
  }

  return context;
}
